import { BiSolidDashboard } from "react-icons/bi";
import Goals from "../../apps/Goals";
import Scheduler from "../../apps/Scheduler";
import SchedulerDashboard from "../../apps/Scheduler/components/Dashboard";
import Workouts from "../../apps/Workouts";
import {
  DialerIcon,
  HomeIcon,
  ScheduleIcon,
  TargetIcon,
  UserIcon,
  WorkoutIcon,
} from "../../assets/images";
import AppSelector from "../../pages/Selector";
import Dialer from "../../apps/Dialer";
import DialerDashboard from "../../apps/Dialer/components/Dashboard";
import ProfilePage from "../../apps/Profile";

const APP_LIST = [
  {
    name: "Scheduler",
    title: "Never Settle",
    path: "scheduler",
    icon: ScheduleIcon,
    info: "Daily tasks to complete",
    element: <Scheduler />,
    children: [
      {
        name: "Scheduler Dashboard",
        path: "/app/scheduler/",
        icon: BiSolidDashboard,
        element: <SchedulerDashboard />,
      },
    ],
  },
  {
    name: "Workouts",
    title: "Plan your workouts",
    path: "workouts",
    icon: WorkoutIcon,
    info: "Workouts Selector",
    element: <Workouts />,
  },
  {
    name: "Goals",
    title: "Match your deadlines",
    path: "goals",
    icon: TargetIcon,
    info: "Goals to achieve till date",
    element: <Goals />,
  },
  {
    name: "Dialer",
    title: "Just dial",
    path: "dialer",
    info: "Call Dialer with frequency",
    icon: DialerIcon,
    element: <Dialer />,
    children: [
      {
        name: "Dialer Dashboard",
        path: "/app/dialer/",
        icon: BiSolidDashboard,
        element: <DialerDashboard />,
      },
    ],
  },
  {
    name: "Profile",
    title: "User Profile",
    path: "profile",
    icon: UserIcon,
    info: "View user profile",
    element: <ProfilePage />,
    hide: true,
  },
];

export const HOME_APP = {
  name: "Home",
  path: "/app/",
  element: <AppSelector apps={APP_LIST} />,
  info: "Apps Selector",
  icon: HomeIcon,
};

export default APP_LIST;
